import { StateCreator } from 'zustand';

import { getAvatarsByUserId } from '@/api/cms/avatars';
import { getActiveAvatar } from '@/helpers/avatar';
import { useCommonStore } from '@/store';
import { getUserId } from '@/store/commonStore/slices/auth/helpers';
import { AvatarState, CommonStoreType } from '@/store/commonStore/types';

export const useAvatarSlice: StateCreator<
  CommonStoreType,
  [],
  [],
  AvatarState
> = (set) => {
  return {
    avatar: getActiveAvatar(null).avatar,
    avatarId: null,
    avatarCmsFieldId: null,
    pendingAvatar: false,
    fetchAvatar: async () => {
      const user = useCommonStore.getState().user;
      const userId = user?.id || getUserId();

      if (!userId) return;

      set({ pendingAvatar: true });
      const { data } = await getAvatarsByUserId(Number(userId));

      if (!data || !data.length) return set({ pendingAvatar: false });

      const avatar = getActiveAvatar(data[0].avatarId).avatar;

      set({
        avatar: avatar ?? null,
        avatarId: data[0].avatarId ?? null,
        avatarCmsFieldId: data[0].id ?? null,
        pendingAvatar: false,
      });
    },
  };
};
